module.exports = __webpack_public_path__ + "img/usdt.f098db06.png";